document.addEventListener('DOMContentLoaded', function () {
    const plusIcons = document.querySelectorAll('.plus-icon');

    plusIcons.forEach(icon => {
        const popup = icon.querySelector('.lookbook-popup');
        const container = icon.closest('.lookbook-item');

        const plusIconWrapper = icon.querySelector('.plus-visible');
        const minusIconWrapper = icon.querySelector('.minus-hidden');

        if (!popup || !container) return;

        let isInside = false;

        function showPopup() {
            popup.style.opacity = '1';
            popup.style.pointerEvents = 'auto';

            // Reset popup styles before adjustment
            popup.style.left = '';
            popup.style.transform = '';

            // Wait for popup to render fully
            requestAnimationFrame(() => {
                const popupRect = popup.getBoundingClientRect();
                const containerRect = container.getBoundingClientRect();

                const defaultLeft = '50%';
                const defaultTransform = popup.classList.contains('popup-top')
                    ? 'translate(-50%, -10px)'
                    : 'translate(-50%, 10px)';

                let adjusted = false;

                if (popupRect.left < containerRect.left) {
                    const shift = containerRect.left - popupRect.left + 8;
                    popup.style.left = `calc(50% + ${shift}px)`;
                    popup.style.transform = defaultTransform;
                    adjusted = true;
                }

                if (popupRect.right > containerRect.right) {
                    const shift = popupRect.right - containerRect.right + 8;
                    popup.style.left = `calc(50% - ${shift}px)`;
                    popup.style.transform = defaultTransform;
                    adjusted = true;
                }

                if (!adjusted) {
                    popup.style.left = defaultLeft;
                    popup.style.transform = defaultTransform;
                }
            });
        }

        function hidePopup() {
            setTimeout(() => {
                if (!isInside) {
                    popup.style.opacity = '';
                    popup.style.pointerEvents = '';
                    popup.style.left = '';
                    popup.style.transform = '';
                }
            }, 150);
        }

        // Only apply hover events on screens wider than 750px
        function isDesktop() {
            return window.innerWidth >= 750;
        }

        icon.addEventListener('mouseenter', () => {
            if (!isDesktop()) return;
            isInside = true;
            icon.classList.add('hovered');
            showPopup();
        });

        icon.addEventListener('mouseleave', () => {
            if (!isDesktop()) return;
            isInside = false;
            icon.classList.remove('hovered');
            hidePopup();
        });

        popup.addEventListener('mouseenter', () => {
            if (!isDesktop()) return;
            isInside = true;
        });

        popup.addEventListener('mouseleave', () => {
            if (!isDesktop()) return;
            isInside = false;
            hidePopup();
        });
    });
});
